import React, { memo, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useDisclosure } from "@chakra-ui/react"
import { Product, ProductVariant } from "@shopify/hydrogen-react/storefront-api-types"

import { ProductStockOverlay } from "./ProductStockOverlay"
import { ProductStockToggle } from "./ProductStockToggle"
import { useShopifyProductLive, useShopifyProductRaw } from "@app/hooks/useShopify"

type Props = {
  disableNoActiveOption: (state: boolean) => void
  handleBackInStock: () => void
  handleQuantity: (quantity: number) => void
  noActiveOption: boolean
  product: Product
  quantity: number
  selectedVariant: ProductVariant | null
  siblings: Array<any>
}

export const ProductStock: React.FC<Props> = memo(
  ({ disableNoActiveOption, handleBackInStock, handleQuantity, noActiveOption, product, quantity, selectedVariant, siblings }) => {
    const { product: settings } = useStaticQuery<GatsbyTypes.ProductStockQuery>(graphql`
      query ProductStock {
        product: sanityTemplateProduct {
          findInStore
        }
      }
    `)

    const [selectedSiblingHandle, setSelectedSiblingHandle] = useState(product?.handle)
    const { isOpen, onToggle } = useDisclosure()

    const selectedSibling = siblings?.find(sibling => sibling?.shopify?.handle === selectedSiblingHandle) || product

    const { product: rawProduct } = useShopifyProductRaw(selectedSibling)
    const { product: liveProduct, loading, isUnavailable } = useShopifyProductLive(rawProduct)

    return settings?.findInStore ? (
      <>
        <ProductStockToggle handleToggle={onToggle} selectedVariant={selectedVariant} />
        {selectedVariant?.sku && (
          <ProductStockOverlay
            disableNoActiveOption={disableNoActiveOption}
            handleBackInStock={handleBackInStock}
            loading={loading}
            handleQuantity={handleQuantity}
            handleToggle={onToggle}
            isOpen={isOpen}
            isUnavailable={isUnavailable}
            noActiveOption={noActiveOption}
            parentProduct={product}
            product={liveProduct || rawProduct}
            siblings={siblings}
            quantity={quantity}
            selectedVariant={selectedVariant}
            setSelectedSiblingHandle={setSelectedSiblingHandle}
          />
        )}
      </>
    ) : null
  }
)
